import { SET_STUDY_ID, RESET_STUDY_ID } from "../utils/constants";

const initialState = {
  studyId: "",
};

const studyReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_STUDY_ID:
      return {
        ...state,
        studyId: action.payload || null,
      };
    case RESET_STUDY_ID:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export default studyReducer;
